import {get} from "../Api";

export async function getDiscountByCode(code) {
    return get('discounts/code/' + code);
}